import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import _ from 'lodash';
import * as moment from 'moment';

interface Range {
  begin: string;
  end: string;
}

/** @deprecated */
@Component({
  selector: 'host-one-month-calendar',
  templateUrl: './one-month-calendar.component.html',
  styleUrls: ['./one-month-calendar.component.scss'],
})
export class OneMonthCalendarComponent implements OnInit {
  @Input() cellWidth = 36;
  @Input() cellHeight = 34;
  @Input() clearContinuousDate = null;
  @Input() defaultDate: Range = null;
  @Input() dateType: 'range' | 'single' = 'range';

  @Output() dateChange = new EventEmitter();

  currentYear = null;
  currentMonth = null;
  rangeDays: Array<string> = [];
  firstCheck = true;
  firstDay = '';
  secondDay = '';
  oldFirstDay = '';
  oldSecondDay = '';
  constructor() {}

  ngOnInit() {
    this.initYearAndMonth();
    if (this.dateType === 'range') {
      this.initRange();
    } else {
      this.initDate();
    }
  }

  initYearAndMonth() {
    if (this.defaultDate) {
      const begin = this.defaultDate.begin;
      this.currentYear = moment(begin).year();
      this.currentMonth = moment(begin).month();
    } else {
      this.currentYear = moment().year();
      this.currentMonth = moment().month();
    }
  }

  initRange() {
    if (this.defaultDate) {
      this.firstDay = this.defaultDate.begin;
      this.secondDay = this.defaultDate.end;
    } else {
      const today = moment().format('YYYY-MM-DD');
      const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD');
      this.firstDay = today;
      this.secondDay = tomorrow;
    }
    const diff = moment(this.secondDay, 'YYYY-MM-DD').diff(moment(this.firstDay, 'YYYY-MM-DD'), 'days');
    for (let i = 1; i < diff; i++) {
      this.rangeDays.push(moment(this.firstDay).add(i, 'days').format('YYYY-MM-DD'));
    }
    this.statitics();
  }

  initDate() {
    if (this.defaultDate) {
      this.firstDay = this.secondDay = this.defaultDate.begin;
    } else {
      const today = moment().format('YYYY-MM-DD');
      this.firstDay = this.secondDay = today;
    }
    this.statitics();
  }

  isSelected(date) {
    if (this.oldFirstDay === date.title || this.oldSecondDay === date.title) {
      date.isSelectedDay = false;
    }
    if (this.firstDay === date.title || this.secondDay === date.title) {
      date.isSelectedDay = true;
    }
    if (this.clearContinuousDate) {
      date.isSelectedDay = false;
      this.clearDays();
    }
    return date.isSelectedDay;
  }

  clearDays() {
    this.rangeDays = [];
    this.firstDay = '';
    this.secondDay = '';
    this.oldFirstDay = '';
    this.oldSecondDay = '';
  }

  isInrange(day) {
    if (_.indexOf(this.rangeDays, day.title) !== -1) {
      return true;
    }
    return false;
  }

  // 可选择过去～6个月内的日期
  isDisableDate(day) {
    const date = _.get(day, 'title');
    const lateDay = moment(date, 'YYYY-MM-DD').isAfter(moment().add(24, 'months'), 'day');
    return lateDay ? true : false;
  }

  isAnotherMonth(day) {
    return day.isLastMonth || day.isNextMonth;
  }

  check(day, e) {
    this.clearContinuousDate = null;
    if (this.isDisableDate(day)) {
      e.stopPropagation();
    } else {
      if (this.dateType === 'range') {
        this.checkDateInRange(day);
      } else {
        this.checkDate(day);
      }
      day.isSelectedDay = !day.isSelectedDay;
    }
  }

  checkDateInRange(day) {
    if (this.firstCheck) {
      this.oldFirstDay = this.firstDay;
      this.oldSecondDay = this.secondDay;
      this.secondDay = '';
      this.rangeDays = [];
      this.firstDay = day.title;
      this.dateChange.emit({
        start: this.firstDay,
        end: null,
        rangeLen: 0,
      });
    } else {
      if (moment(day.title, 'YYYY-MM-DD').isBefore(moment(this.firstDay, 'YYYY-MM-DD'))) {
        this.secondDay = this.firstDay;
        this.firstDay = day.title;
      } else {
        this.secondDay = day.title;
      }
      const diff = moment(this.secondDay, 'YYYY-MM-DD').diff(moment(this.firstDay, 'YYYY-MM-DD'), 'days');
      for (let i = 1; i < diff; i++) {
        this.rangeDays.push(moment(this.firstDay).add(i, 'days').format('YYYY-MM-DD'));
      }
      this.statitics();
    }
    this.firstCheck = !this.firstCheck;
  }

  checkDate(day) {
    this.oldFirstDay = this.oldSecondDay = this.firstDay;
    this.firstDay = this.secondDay = day.title;
    this.statitics();
  }

  statitics() {
    if (this.dateType === 'range') {
      this.dateChange.emit({
        start: this.firstDay,
        end: this.secondDay,
        rangeLen: this.rangeDays.length + 2,
      });
    } else {
      this.dateChange.emit({
        date: this.firstDay,
      });
    }
  }

  yearChange(year) {
    this.currentYear = year;
  }

  monthChange(month) {
    this.currentMonth = month;
  }

  subMonth(date) {
    this.currentYear = date.year;
    this.currentMonth = date.month;
  }

  addMonth(date) {
    this.currentYear = date.year;
    this.currentMonth = date.month;
  }
}
